<template>
  <div class="shipment-tag-wrapper shipment-tag-jadlog-smartlabel">
    <div class="shipment-root">
      <div class="row">
        <div class="wrapper-outer">
          <div class="wrapper-inner">
            <img :src="shippingCompanyIcon" class="in-center jadlog-header-logo">
          </div>
          <div class="wrapper-inner">
            <div
              v-show="$parent.tag.authorizationCode && $parent.tag.protocol"
              class="jadlog-header-protocol"
            >
              <p>{{ $parent.tag.protocol }}</p>
              <p
                v-if="isIndustrialService(Number($parent.tag.serviceId))"
                class="jadlog-header-protocol__ind"
              >
                IND
              </p>
            </div>
          </div>
          <div class="wrapper-inner">
            <img :src="$parent.tag.companyIcon" class="in-center jadlog-header-logo">
          </div>
        </div>
      </div>
      <div class="container-information">
        <div class="wrapper-inner">
          <div class="row box-double-content height-large">
            <div class="wrapper-outer">
              <ul>
                <li>
                  {{ $parent.tag.to.address }}<template v-if="$parent.tag.to.locationNumber.length">, </template>
                  {{ $parent.tag.to.locationNumber }}
                </li>
                <li>
                  {{ $parent.tag.to.complement }}<template v-if="$parent.tag.to.complement.length">, </template>
                  {{ $parent.tag.to.district }}
                </li>
                <li>
                  <strong>{{ beautifyPostalCode($parent.tag.to.postalCode) }}</strong>
                  {{ $parent.tag.to.city }}<template v-if="$parent.tag.to.stateAbbr.length">/</template>{{ $parent.tag.to.stateAbbr }}
                </li>
                <li v-if="$parent.tag.to.note" class="spacing-small">
                  <strong>obs: </strong> {{ $parent.tag.to.note }}
                </li>
              </ul>
            </div>
          </div>
          <div class="row box-between height-medium">
            <div class="wrapper-outer">
              <ul class="recipient-contact-wrapper">
                <li class="font-little">
                  Contato:
                  <div class="name">
                    {{ String($parent.tag.to.name).toUpperCase() }}
                  </div>
                </li>
                <li class="font-little">
                  Telefone:
                  <span class="phone">
                    <template v-if="$parent.tag.to.phone.length">{{ maskPhone($parent.tag.to.phone) }}</template>
                  </span>
                </li>
              </ul>
              <ul>
                <li class="font-little">Pacotes</li>
                <li
                  v-if="$parent.volume.seqVolume"
                  class="font-medium font-bold"
                >
                  {{ packages }}
                </li>
              </ul>
            </div>
          </div>
          <div class="row box-between">
            <div class="wrapper-outer">
              <ul class="space-y">
                <li>
                  <span v-if="$parent.tag.invoice.number">NF: {{ $parent.tag.invoice.number }}</span>
                  <span v-else>DECLARACAO</span>
                </li>
                <li class="font-little">Unidade Jadlog de destino:</li>
                <li>{{ $parent.volume.unidadeDestino }}</li>
                <li>{{ $parent.tag.authorizationCode }}</li>
              </ul>
              <ul>
                <li>{{ $parent.volume.prioridade }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="wrapper-inner">
          <div class="row">
            <div class="wrapper-outer horizontal-wrapper">
              <h2>{{ $parent.volume.rua }}</h2>
              <h3>{{ $parent.volume.posicao }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="wrapper-outer horizontal-wrapper">
              <p>
                {{ $parent.tag.from.name }}
              </p>
              <p>
                {{ $parent.tag.from.address }}<template v-if="$parent.tag.from.locationNumber.length">, </template>
                {{ $parent.tag.from.locationNumber }}
              </p>
              <p>
                {{ $parent.tag.from.complement }}<template v-if="$parent.tag.from.complement.length">, </template>
                {{ $parent.tag.from.district }}
              </p>
              <p>
                {{ beautifyPostalCode($parent.tag.from.postalCode) }}
                {{ $parent.tag.from.city }}<template v-if="$parent.tag.from.stateAbbr.length">/</template>{{ $parent.tag.from.stateAbbr }}
              </p>
            </div>
          </div>
        </div>
        <div class="wrapper-inner">
          <div class="bar-code">
            <canvas class="barcode img-code"
              :data-value="`${ $parent.tag.additionalInfo.shipmentId }$${ $parent.volume.seqVolume.toString().padStart(3, '0')}`"
              data-height="55"
              data-margin="0"
              data-font="arial"
              data-displayvalue="false"
              data-textposition="bottom">
            </canvas>
          </div>
        </div>
      </div>
      <div class="container-jadlog">
        <div class="row">
          <div class="box-between first-line-container">
            <div class="row">
              <h2 class="font-medium">
                <strong>{{ String($parent.tag.additionalInfo.shipmentId).substring(0, 6) }}</strong>
                {{ String($parent.tag.additionalInfo.shipmentId).substring(6, 10) }}
                {{ String($parent.tag.additionalInfo.shipmentId).substring(10, 14) }}
              </h2>
              <p class="font-bold">{{ serviceName }}</p>
            </div>
          </div>
          <div class="wrapper-outer">
            <div class="content">
              <span class="font-little">Track</span>
              <div class="block">{{ $parent.volume.prioridade }}</div>
            </div>
          </div>
          <div class="wrapper-outer">
            <div class="content">
              <h2 class="">{{ $parent.volume.rota }}</h2>
            </div>
          </div>
          <div class="wrapper-outer lastMile">
            <div class="content">
              <h2 class="">{{ $parent.volume.lastMile }}</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="bar-code-bottom">
            <canvas class="barcode scale"
                 :data-value="$parent.volume.codbarra"
                 data-width="1"
                 data-height="70"
                 data-margin="0"
                 data-font="arial"
                 data-displayvalue="false"
                 data-textposition="bottom">
            </canvas>
          </div>
           <p class="font-little" style="padding-top: 3px">{{ handleBarcode() }}</p>
        </div>
        <div class="row" style="padding: 0">
          <div class="bar-code-bottom" style="padding-top: 5px">
            <canvas class="barcode barcode-small"
                 :data-value="$parent.tag.authorizationCode || 'MELHOR ENVIO'"
                 data-height="30"
                 data-margin="0"
                 data-font="arial"
                 data-fontsize="14"
                 data-textposition="top">
            </canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { kilogramsToGrams, maskPhone } from 'commons/js/formatters/Mask';
import { beautifyPostalCode } from 'commons/js/formatters/PostalCode';
import ShippingDefinitions from 'commons/js/ShippingDefinitions';

export default {
  name: 'jadlog-shipment-tag',

  mixins: [
    ShippingDefinitions,
  ],

  data() {
    return {
      shippingCompanyIcon: ''
    }
  },

  computed: {
    serviceName: function () {
      switch (Number(this.$parent.tag.serviceId)) {
        case ShippingDefinitions.JADLOG_DOTPACKAGE_ID:
        case ShippingDefinitions.JADLOG_DOTPACKAGECENTRALIZADO_ID:
          return 'PAK';
        case ShippingDefinitions.JADLOG_DOTCOM_ID:
          return 'COM';
      }
      return 'ECO';
    },

    packages() {
      const volume = (this.$parent.tag.volumeIndex + 1).toString().padStart(3, '0');
      const total = this.$parent.tag.volumeTotal.toString().padStart(3, '0');

      return `${volume}/${total}`;
    },
  },

  mounted() {
    BarCode('.barcode').init();

    switch (Number(this.$parent.tag.serviceId)) {
      case ShippingDefinitions.JADLOG_DOTPACKAGE_ID:
      case ShippingDefinitions.JADLOG_DOTPACKAGECENTRALIZADO_ID:
        this.shippingCompanyIcon = '/images/shipment/jadlog/dot-package.png';
        break;
      case ShippingDefinitions.JADLOG_DOTCOM_ID:
        this.shippingCompanyIcon = '/images/shipment/jadlog/dot-com.png';
        break;
    }
  },

  methods: {
    handleBarcode() {
      const barcode = String(this.$parent.volume.codbarra);

      return (
        barcode
          .replace('$', '')
          .match(/.{1,4}/g) // match any character, at least 1 and at most 4
          .join(' ')
      );
    },
    kilogramsToGrams,
    maskPhone,
    beautifyPostalCode
  }
}
</script>


<style lang="stylus" scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto:400,700')
.shipment-tag-jadlog-smartlabel
  .shipment-root
    max-width 420px
    margin 0 auto
    font-size 12px
    font-family 'Roboto', Arial, Helvetica, sans-serif
    height 100%
    & > .row
      .wrapper-outer
        justify-content space-between
        align-items center
        overflow hidden
        .jadlog-header-logo
          width 80px
          display block
          &:first-child
            width 70px
            padding 5px 0
        .jadlog-header-protocol
          position relative
          font-size 9pt
          font-weight bold
          text-align center
          &__ind
            position absolute
            top 100%
            left 50%
            transform translateX(-50%)
  .font-medium
    font-size 14px
  .font-little
    font-size 10px
  .font-bold
    font-weight 800
  ul
    list-style-type none
    padding 0
    margin 0
  .row
    width 100%
    border-bottom 1px solid #000
  .container-information
    .wrapper-inner
      display flex
      border-bottom 1px solid #000
      .row
        justify-content space-between
        &:last-child
          border-bottom none
        .recipient-contact-wrapper
          word-break break-word
          ul
            &:first-child
              width 75%
      &:first-child
        max-width 275px
        width 100%
        align-content flex-end
      &:nth-child(2)
        width 70px
        border-right 1px solid #000
        border-left 1px solid #000
        .row
          &:last-child
            border none
            height 150px
            position relative
            .wrapper-outer
              transform rotate(90deg)
              position absolute
              top 60px
              width 150px
              left -55px
          &:first-child
            .wrapper-outer
              align-items center
              &:nth-child(2)
                width 255px
            h3
              font-size 35px
            h2
              font-size 60px
              font-weight 900
      &:first-child
        .box-between
          &:nth-child(2)
            .wrapper-outer
              ul
                li
                  margin 3px 0
        &:last-child
          .wrapper-outer
            ul
              &:first-child
                max-width 165px
                li
                  &:first-child
                    margin-bottom 5px
              &:last-child
                li
                  display flex
                  justify-content center
                  font-size 60px
                  font-weight 900
      &:last-child
        position relative
        width 55px
    .row
      &.box-double-content
        display flex
        justify-content space-between
        height 80px
        padding-top 5px
        .wrapper-outer
          ul
            li
              margin 2px 0
  .wrapper-inner
    display flex
    flex-direction column
    .box-between
      &:nth-child(2)
        .wrapper-outer
          height 72px
      &:last-child
        .wrapper-outer
          height 82px
  .wrapper-outer
    padding 0 8px
    display flex
    justify-content space-between
  .box-between
    &:nth-child(2)
      .wrapper-outer
        ul
          &:last-child
            .font-little
              margin-bottom 4px
    .wrapper-outer
      ul
        &:last-child
          flex-direction column
          border-left 1px solid #000
          padding-left 8px
          display flex
          width 50px
    &:last-child
      .wrapper-outer
        ul
          &:last-child
            justify-content center
  h4
    margin 0
    > span
      margin 0 3px
  h1
  h2
  h3
  h5
  p
    margin 0
  .horizontal-wrapper
    display flex
    flex-direction column
    p
      font-size 9px
  .bar-code-bottom
    width 100%
    overflow hidden
    height 53px
    display flex
    justify-content center
    .img-code-bottom
      width auto
      height 130px
      z-index 0
      position relative
      top -8px
    .scale
      transform scaleX(1.5) !important
  .bar-code
    width 100%
    overflow hidden
    height 250px
    position relative
    .img-code
      transform rotate(90deg) !important
      position relative
      height 38px
      top 107px
      left -90px
      z-index 0
      rect
        height 60px
  .container-jadlog
    .row
      flex-wrap wrap
      display flex
      border-bottom none
      .first-line-container
        padding 0 5px
        > .row
          display flex
          justify-content flex-start
          .font-medium
            margin-right 80px
      .box-between
        display flex
        justify-content space-between
      &:nth-child(2)
      &:nth-child(3)
        flex-grow 0.3
        display flex
        flex-direction column
        p
          text-align center
      &:nth-child(3)
        border-top 1px solid #000
        margin-top 8px
        padding-top 8px
        padding-bottom 8px
      &:first-child
        .wrapper-outer
          display flex
          flex-direction column
          .content
            display flex
            flex-direction column
            justify-content center
          h4
            font-weight 800
        .box-between
          width 100%
      .wrapper-outer
        &:nth-child(3)
          justify-content center
          padding-right 0
          width 200px
          align-items flex-end
          h2
            font-size 18px
            margin-right 10px
        &:nth-child(2)
          max-width 60px
          .content
            height 50px
            display flex
            justify-content center
        &:last-child
          width 70px
          justify-content flex-start
          p
            text-align right
            margin-bottom 10px
        &.lastMile
          align-items flex-end
          justify-content flex-end
          .content
            margin-bottom 0.5rem
    .wrapper-outer
      &:nth-child(2)
        width 225px
  .block
    text-align center
    border 1px solid #000
    width 15px
    height 15px
    display flex
    justify-content center
    align-items center
  .height-large
    height 90px !important
  .height-medium
    height 72px !important
  .space-y
    padding 2px 0 5px 0
  .spacing-small
    margin-top 8px

@media print
  .shipment-tag-jadlog
    .shipment-tag-header
      height 110px !important

      img
        width 85%

      .code
        transform translate(-50%, -50%) scale(1.45) !important
    .shipment-tag-website
      display block
</style>
